import { type FC, type ReactNode } from 'react';

import { Button } from '../Button';
import { Icon } from '../Icon';
import { type TooltipPosition, Tooltip } from '../Tooltip';

export type InfoTooltipProps = {
  label: string;
  content: ReactNode;
  position?: TooltipPosition;
  className?: string;
};

const InfoTooltip: FC<InfoTooltipProps> = ({
  label,
  content,
  position = 'top',
  className,
}) => (
  <Tooltip
    content={content}
    position={position}
    openOnClick
    className={className}
  >
    <Button
      variant="text"
      size="xs"
      icon={<Icon variant="CircleInfo" size="small" />}
      aria-label={label}
      style={{ color: 'inherit', backgroundColor: 'transparent' }}
    />
  </Tooltip>
);

InfoTooltip.displayName = 'InfoTooltip';

export default InfoTooltip;
